import fp from 'lodash/fp';

// eslint-disable-next-line import/prefer-default-export
export const createCsaList = fp.map(csa => ({
    value: csa.csa,
    title: csa.csa,
    counterparty: csa.counterparty,
    type: csa.csaType
}));
